import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExternalLinkIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_1056_11207",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 20,
			height: 20,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_1056_11207)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M4.67962 16.6668C4.29601 16.6668 3.97574 16.5384 3.71879 16.2814C3.46185 16.0245 3.33337 15.7042 3.33337 15.3206V4.67975C3.33337 4.29613 3.46185 3.97586 3.71879 3.71891C3.97574 3.46197 4.29601 3.3335 4.67962 3.3335H9.359V4.16683H4.67962C4.55129 4.16683 4.43372 4.22023 4.32692 4.32704C4.22011 4.43384 4.16671 4.55141 4.16671 4.67975V15.3206C4.16671 15.4489 4.22011 15.5665 4.32692 15.6733C4.43372 15.7801 4.55129 15.8335 4.67962 15.8335H15.3205C15.4488 15.8335 15.5664 15.7801 15.6732 15.6733C15.78 15.5665 15.8334 15.4489 15.8334 15.3206V10.6412H16.6667V15.3206C16.6667 15.7042 16.5382 16.0245 16.2813 16.2814C16.0243 16.5384 15.7041 16.6668 15.3205 16.6668H4.67962ZM8.11546 12.4745L7.52567 11.8847L15.2436 4.16683H11.6667V3.3335H16.6667V8.3335H15.8334V4.75662L8.11546 12.4745Z",
				fill: "#1C1B1F"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgExternalLinkIcon);
export { ForwardRef as ReactComponent };
